import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const RedeemCode = () => {
  const { setUser } = useAuth();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/access-code/redeem", { code });
      setUser(data);
      setCode("");
      toast.success("Code validé ! Tu as maintenant l'offre Pro illimitée, offerte.");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="card-flat mt-8 flex flex-col gap-4 p-6 sm:flex-row sm:items-center" data-testid="redeem-code-form">
      <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent text-accent-foreground"><KeyRound className="h-5 w-5" /></span>
      <div className="flex-1">
        <p className="font-semibold">Tu as un code d'accès ?</p>
        <p className="text-sm text-muted-foreground">Un code fourni par l'équipe NoteMyClass débloque l'offre Pro illimitée gratuitement.</p>
      </div>
      <input data-testid="redeem-code-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="NMC-XXXX-XXXX-XXXX" maxLength={40}
        className="h-11 rounded-full border bg-background px-4 font-mono text-sm uppercase outline-none focus:border-primary/50 sm:w-60" />
      <button data-testid="redeem-code-submit" disabled={code.trim().length < 4 || busy} className="bg-brand inline-flex h-11 items-center justify-center gap-2 rounded-full px-5 text-sm font-semibold text-white disabled:opacity-50">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Activer
      </button>
    </form>
  );
};
